<template>
  <div @click.self="close" class="modal-background">
    <div class="modal-wrapper">
      <div class="modal" :class="{ modalscroll: filter}">
        <div class="modal-container">
          <div class="picker-header">
            <div class="picker-label">{{label}}</div>
            <img @click="close" class="close" src="/img/icons/icon-close-black.svg">
          </div>
          <ria-input v-if="filter" :label="$t('participants.search')" :value="search" type="text" @change="changeFilterValue"/>
          <div v-for="option in listOptions" :key="option.value" class="picker-options">
            <div class="picker-option" @click="() => select(option.value)">{{ option.name }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import RiaInput from "./ria-input";

  export default {
    name: "ria-picker",
    props: {
      closeButtonText: String,
      options: Array,
      filter: {
        type: Boolean,
        default: false
      },
      label: String
    },
    components: {
      RiaInput
    },
    data() {
      return {
        search: ''
      }
    },
    computed: {
      listOptions() {
        if (this.filter && this.search != '') {
          return this.options.filter(option => option.name && option.name.toLowerCase().includes(this.search))
        }
        return this.options
      }
    },
    methods: {
      close() {
        this.$emit('close')
      },
      select(value) {
        this.$emit('select', value)
        this.$emit('close')
      },
      changeFilterValue: function({ value }) {
        this.search = value;
      },
    },
  };
</script>

<style scoped>

  .modal-background {
    @apply fixed w-full h-full inset-0 flex flex-col-reverse bg-grey-transparent z-50;
  }

  .modal-wrapper {
    @apply h-full w-full flex items-center justify-center
  }

  .modal {
    @apply bg-white w-full;
  }

  .modalscroll {
    overflow-y: scroll;
    max-height:50%;
  }

  .modal-container {
    @apply px-5.5 border-b-1 border-grey-border flex flex-col text-black;
  }

  .c {
    @apply w-full pt-6 pb-8 px-5 text-grey-text text-left border-b-1 border-grey-border;
  }

  .picker-header {
    @apply flex justify-between py-3 font-medium
  }

  .picker-label {
    @apply flex-1
  }

  .picker-option {
    @apply w-full
  }

  .close {
    @apply w-6 h-6 object-contain;
  }

  .picker-options {
    @apply flex justify-between py-3
  }

  @screen lg {
    .modal {
      @apply bg-white w-1/4;
    }
  }

</style>

